import * as PropTypes from 'prop-types'
import { styled } from 'next-yak'

import * as fonts from '../constants/fonts.js'
import * as colors from '../constants/colors.ts'
import * as utils from '../utils'

export const BasicLink = styled.a`
  font-family: ${fonts.PRIMARY_FONT};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`

export const PrimaryLink = styled(BasicLink)`
  color: ${(props) => utils.colors.primary(props)};
  text-decoration: none;
  transition: color 200ms ease-in-out;

  &:hover {
    color: ${(props) => utils.colors.hexToRgb(utils.colors.primary(props), 0.85)};
  }
`

PrimaryLink.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export const SecondaryLink = styled(BasicLink)`
  color: ${colors.TEXT_PRIMARY};
  text-decoration: none;
  transition: color 200ms ease-in-out;

  &:hover {
    color: ${() => utils.colors.hexToRgb(colors.TEXT_PRIMARY, 0.85)};
  }
`

SecondaryLink.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export const TertiaryLink = styled(BasicLink)`
  color: ${colors.TEXT_TERTIARY};
  text-decoration: none;
  transition: text-decoration 200ms ease-in-out;

  &:hover {
    text-decoration: underline;
    color: ${() => utils.colors.hexToRgb(colors.TEXT_TERTIARY, 0.85)};
  }
`

TertiaryLink.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
